import $axios from '@/helpers/axios';
import dataStore from '@/helpers/data';
import helperError from '@/helpers/error';
import language from '@/helpers/language';
const state = {
  list: [],
};
const getters = {
  staff: (state) => state,
};
const actions = {
  async list({ commit }) {
    this.dispatch('app/loading', true);
    return await $axios.get('/staff').then(
      (response) => {
        this.dispatch('app/loading', false);
        commit('SET_LIST', response.data.response);
      },
      (error) => {
        helperError(this, error, language(dataStore.language.current)['errorOccured']);
      }
    );
  },
};
const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
